<app-page-header [pageTitle]="'Stock'" />

<mat-tab-group [(selectedIndex)]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
  @if (tabs.includes('semen')) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="dark:text-white/90">Stock de Semen</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="pt-6">
          <app-stock-semen />
        </div>
      </ng-template>
    </mat-tab>
  }

  @if (tabs.includes('embriones')) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="dark:text-white/90">Embriones Congelados</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="pt-6">
          <app-stock-embriones-congelados />
        </div>
      </ng-template>
    </mat-tab>
  }

  @if (tabs.includes('frescos')) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="dark:text-white/90">Embriones Frescos</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="pt-6">
          <app-stock-embriones-frescos />
        </div>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
